/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Assetinfo_Generic1Inputs */

const id_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File generik atau kode sumber.`)
};

const ms_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail generik atau kod sumber.`)
};

const da_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En generisk fil eller kildekode.`)
};

const de_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine generische Datei oder Quellcode.`)
};

const en_us2_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A generic file or source code.`)
};

const es_es2_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un archivo genérico o código fuente.`)
};

const es_mx2_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un archivo genérico o código fuente.`)
};

const fil_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang generic na file o source code.`)
};

const fr_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fichier générique ou le code source.`)
};

const it_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un file generico o codice sorgente.`)
};

const hu_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Általános fájl vagy forráskód.`)
};

const nl_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een generiek bestand of broncode.`)
};

const no_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En generisk fil eller kildekode.`)
};

const pl_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogólny plik lub kod źródłowy.`)
};

const pt_br2_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um arquivo genérico ou código-fonte.`)
};

const pt_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ficheiro genérico ou código-fonte.`)
};

const ro_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fișier generic sau cod sursă.`)
};

const fi_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleinen tiedosto tai lähdekoodi.`)
};

const sv_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En generisk fil eller källkod.`)
};

const vi_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp chung hoặc mã nguồn.`)
};

const tr_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genel bir dosya veya kaynak kodu.`)
};

const cs_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecný soubor nebo zdrojový kód.`)
};

const bg_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ файл или изходен код.`)
};

const ru_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общий файл или исходный код.`)
};

const uk_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загальний файл або вихідний код.`)
};

const ar_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملف عام أو كود مصدري.`)
};

const hi_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य फ़ाइल या स्रोत कोड।`)
};

const th_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฟล์ทั่วไปหรือซอร์สโค้ด`)
};

const ja_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汎用ファイルまたはソースコード。`)
};

const zh_cn2_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通用文件或源代码。`)
};

const zh_hant1_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通用檔案或原始碼。`)
};

const ko_misc_downloads_assetinfo_generic1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Generic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반 파일 또는 소스 코드입니다.`)
};

/**
* | output |
* | --- |
* | "A generic file or source code." |
*
* @param {Misc_Downloads_Assetinfo_Generic1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_assetinfo_generic1 = /** @type {((inputs?: Misc_Downloads_Assetinfo_Generic1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Assetinfo_Generic1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "ms") return ms_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "da") return da_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "de") return de_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "fil") return fil_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "fr") return fr_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "it") return it_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "hu") return hu_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "nl") return nl_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "no") return no_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "pl") return pl_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "pt") return pt_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "ro") return ro_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "fi") return fi_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "sv") return sv_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "vi") return vi_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "tr") return tr_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "cs") return cs_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "bg") return bg_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "ru") return ru_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "uk") return uk_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "ar") return ar_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "hi") return hi_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "th") return th_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "ja") return ja_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_assetinfo_generic1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_assetinfo_generic1(inputs)
	return ko_misc_downloads_assetinfo_generic1(inputs)
});
export { misc_downloads_assetinfo_generic1 as "misc.downloads.assetInfo.generic" }